import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import * as PXBColors from '@brightlayer-ui/colors';
import { useLanguageLocale } from '../../hooks/language-locale-hooks'
import { Close } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { ItemList } from '../../types/logbook-type';
import { useOrganizationList } from '../../data/DataProviders/OrganizationListProvider';
import { useDispatch, useSelector } from 'react-redux';
import { Selectors } from '../../selectors';
import { BuildingList } from '../../types/building';
import { Thunks } from '../../actions';
import { customerListV2Data } from '../../types/customer-detail';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useHistory } from 'react-router-dom';
import { ActionType } from '../../constants';
import { DeviceList } from '../../types/device';

type Props = {
    openDialog: boolean
    setOpenMaintenancePopup: Function
}
const CreateMaintenanceDialog = (props: Props) => {
    const { t } = useLanguageLocale();
    const history = useHistory();
    const DEFAULT_ID: string = '';
    const useOrganizationDataList = useOrganizationList();
    const dispatch = useDispatch();
    const dashboard = useSelector(Selectors.Dashboard.dashboard);
    const asset = useSelector(Selectors.Dashboard.asset);
    const customer = useSelector(Selectors.Customer.customer);
    const [projectId, setProjectId] = useState('');
    const [serviceOrganizationListData, setServiceOrganizationListData] = useState<ItemList>([]);
    const [buildingId, setBuildingId] = useState(DEFAULT_ID);
    const [buildings, setBuildings] = useState<ItemList>([]);
    const [customerId, setCustomerId] = React.useState('');
    const [customers, setCustomers] = React.useState<ItemList>([]);
    const [deviceId, setDeviceId] = React.useState('');
    const [systemList, setSystemList] = useState<ItemList>([]);
    const disableButton = projectId && buildingId && deviceId && customerId;

    useEffect(() => {
        setServiceOrganizationListData(useOrganizationDataList.organizationList);
    }, [useOrganizationDataList, useOrganizationDataList.organizationList]); //eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        dispatch(Thunks.Dashboard.getBuildingList(projectId, DEFAULT_ID, DEFAULT_ID, DEFAULT_ID, [], null, null, false, true));
        dispatch(Thunks.Customer.getCustomerListV2(projectId));
        dispatch(Thunks.Asset.getDeviceList(projectId, buildingId, DEFAULT_ID, DEFAULT_ID, DEFAULT_ID));
        setBuildings([]);
        setSystemList([]);
        setCustomers([]);
        setCustomerId(DEFAULT_ID);
        // eslint-disable-next-line
    }, [projectId, buildingId]);


    const customerListData = (list: customerListV2Data): ItemList => {
        return list?.map((data, customer) => {
            return {
                id: data.id,
                name: data.companyName,
                number: data.customerNumber
            };
        });
    };

    useEffect(() => {
        if (!customer.customerListLoading && customer.customerListSuccess) {
            setCustomers(customerListData(customer.customerList.customerDetailList));
        }
        else if (!customer.customerListLoading && customer.customerListFail) {
            setCustomers([]);
        }
    }, [customer.customerListLoading, customer.customerListSuccess, customer.customerListFail]); // eslint-disable-line react-hooks/exhaustive-deps

    const buildingListData = (list: BuildingList): ItemList => {
        return list?.map((data, building) => {
            return {
                id: data.buildingId,
                name: data.name,
            };
        });
    };

    useEffect(() => {
        if (!dashboard.buildingListLoading && dashboard.buildingListSuccess) {
            setBuildings(buildingListData(dashboard.buildingList.detail));

        } else if (!dashboard.buildingListLoading && dashboard.buildingListFail) {
            setBuildings([]);
        }
    }, [dashboard.buildingListLoading, dashboard.buildingListSuccess, dashboard.buildingListFail]); // eslint-disable-line react-hooks/exhaustive-deps

    const systemListLogbook = (list: DeviceList): ItemList => {
        return list?.map((data, system) => {
            return {
                id: data.systemId,
                name: data.systemName,
            };
        });
    };

    useEffect(() => {
        if (!asset.deviceListLoading && asset.deviceListSuccess) {
            setSystemList(systemListLogbook(asset.deviceList.detail));

        } else if (!asset.deviceListLoading && asset.deviceListFail) {
            setSystemList([]);
        }
    }, [asset.deviceListLoading, asset.deviceListSuccess, asset.deviceListFail]);// eslint-disable-line react-hooks/exhaustive-deps

    const handleSetOrganization = (event: SelectChangeEvent) => {
        setProjectId(event.target.value);
    };

    const handleSetbuildingSelection = (event: SelectChangeEvent) => {
        setBuildingId(event.target.value);
    };

    const handleSetsystemSelection = (event: SelectChangeEvent) => {
        setDeviceId(event.target.value);
    };

    const handleSetcustomerSelection = (event: SelectChangeEvent) => {
        setCustomerId(event.target.value);
    };

    const NavigateToCreateMaintainence = (): void => {
        pushAppRoute(history,
            { type: 'CreateMaintainence', systemId: deviceId, buildingId: buildingId, actionType: ActionType.ADD }
        );
    };


    const onCancel = (): void => {
        props.setOpenMaintenancePopup(false)
        setProjectId(DEFAULT_ID);
        setBuildingId(DEFAULT_ID);
        setDeviceId(DEFAULT_ID);
        setCustomerId(DEFAULT_ID);


    }
    return (
        <>
            <Dialog data-testid='createMaintenanceDialog' id="create-maintenance-dialog" maxWidth="md" open={props.openDialog} onClose={onCancel}>
                <IconButton style={{
                    position: 'absolute',
                    right: 20,
                    top: 12
                }}
                    data-testid="close-create-maintenance-button"
                    onClick={onCancel}>
                    <Close fontSize="medium" />
                </IconButton>
                <DialogTitle data-testid='createMaintenanceDialogHeader'>{t('MAINTENANCE_DETAILS.CREATE_MAINTENANCE_DIALOG_HEADER')}</DialogTitle>
                <Divider />
                <DialogContent data-testid='checkId' style={{ width: 900, paddingTop: 24, backgroundColor: PXBColors.gray[50] }}>
                    <>
                        <Box
                            data-testid='maintenanceContainer'
                            id="maintenance-Container"
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: '40% 7% 50%',
                                gap: 2,
                            }}>

                            <Box sx={{ backgroundColor: PXBColors.white[100] }}>
                                <div style={{ padding: 10 }}>
                                    <Typography sx={{ fontSize: 16, fontWeight: 600, marginBottom: 2 }}>
                                        {t('MAINTENANCE_DETAILS.SEARCH_BY_SLA')}
                                    </Typography>
                                    <FormControl variant={'filled'} fullWidth>
                                        <InputLabel data-testid='inputLabel' >
                                            {t('DEVICE_DETAILS.SLA_NUMBER')}
                                        </InputLabel>
                                        <Select
                                            variant={'filled'}
                                            fullWidth style={{ marginBottom: 24, backgroundColor: PXBColors.white[500] }}
                                            labelId="add-sla-select-label"
                                            inputProps={{ 'data-testid': 'sla-select' }}
                                            data-testid="select-SLA-maintenance"
                                            displayEmpty={true}
                                            disabled={true}
                                        >
                                        </Select>
                                    </FormControl>
                                </div>
                            </Box>
                            <Box sx={{ fontSize: 16, fontWeight: 600, marginTop: 2, marginLeft: 2, marginRight: 2 }}>
                                {t('ACTIONS.OR')}
                            </Box>
                            <Box sx={{ backgroundColor: PXBColors.white[100] }}>
                                <div style={{ padding: 10 }}>
                                    <Typography sx={{ fontSize: 16, fontWeight: 600, marginBottom: 2 }}>
                                        {t('MAINTENANCE_DETAILS.SEARCH_BY_ASSET')}
                                    </Typography>
                                    <div>
                                        <FormControl variant={'filled'} fullWidth required>
                                            <InputLabel data-testid='inputLabel1' >
                                                {t('ENTITY_TYPE.ORGANIZATION')}
                                            </InputLabel>
                                            <Select
                                                variant={'filled'}
                                                fullWidth style={{ marginBottom: 24, backgroundColor: PXBColors.white[500] }}
                                                labelId="addorg-select-label"
                                                inputProps={{ 'data-testid': 'select-maintenance' }}
                                                data-testid="select-org-maintenance"
                                                value={projectId}
                                                onChange={handleSetOrganization}
                                                displayEmpty={true}

                                            >
                                                {serviceOrganizationListData.map((data) => {
                                                    return (
                                                        <MenuItem id="add-org-list" key={data.id} value={data.id}
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'left', fontSize: 14,
                                                                lineHeight: 1.5, fontWeight: 400,
                                                                overflow: 'hidden',
                                                                boxSizing: 'border-box',
                                                                whiteSpace: 'nowrap',
                                                                minHeight: 48,
                                                                paddingTop: 6,
                                                                paddingBottom: 6,
                                                                width: 'auto',
                                                                paddingLeft: 16,
                                                                paddingRight: 16
                                                            }}>
                                                            {data.name}
                                                        </MenuItem>

                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div>
                                        <FormControl variant={'filled'} fullWidth required>
                                            <InputLabel data-testid='inputLabel2' >
                                                {t('ENTITY_TYPE.BUILDING')}
                                            </InputLabel>
                                            <Select
                                                variant={'filled'}
                                                fullWidth style={{ marginBottom: 24, backgroundColor: PXBColors.white[500] }}
                                                labelId="addBuilding-select-label"
                                                inputProps={{ 'data-testid': 'addBuilding' }}
                                                data-testid="addBuilding-select"
                                                value={buildingId}
                                                onChange={handleSetbuildingSelection}
                                                displayEmpty={!projectId && dashboard.buildingListLoading}

                                            >
                                                {buildings.map((data) => {
                                                    return (
                                                        <MenuItem id="building-list" key={data.id} value={data.id}
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'left', fontSize: 14,
                                                                lineHeight: 1.5, fontWeight: 400,
                                                                overflow: 'hidden',
                                                                boxSizing: 'border-box',
                                                                whiteSpace: 'nowrap',
                                                                minHeight: 48,
                                                                paddingTop: 6,
                                                                paddingBottom: 6,
                                                                width: 'auto',
                                                                paddingLeft: 16,
                                                                paddingRight: 16
                                                            }}>
                                                            {data.name}

                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div>
                                        <FormControl variant={'filled'} fullWidth required>
                                            <InputLabel data-testid='inputLabel3' >
                                                {t('ENTITY_TYPE.SYSTEM')}
                                            </InputLabel>
                                            <Select
                                                variant={'filled'}
                                                fullWidth style={{ marginBottom: 24, backgroundColor: PXBColors.white[500] }}
                                                labelId="deviceId-select-label"
                                                inputProps={{ 'data-testid': 'deviceIdSelect' }}
                                                data-testid="deviceId-select"
                                                value={deviceId}
                                                onChange={handleSetsystemSelection}
                                                displayEmpty={!buildingId && asset.deviceListLoading}

                                            >
                                                {systemList.map((data) => {
                                                    return (
                                                        <MenuItem id="system-list" key={data.id} value={data.id}
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'left', fontSize: 14,
                                                                lineHeight: 1.5, fontWeight: 400,
                                                                overflow: 'hidden',
                                                                boxSizing: 'border-box',
                                                                whiteSpace: 'nowrap',
                                                                minHeight: 48,
                                                                paddingTop: 6,
                                                                paddingBottom: 6,
                                                                width: 'auto',
                                                                paddingLeft: 16,
                                                                paddingRight: 16
                                                            }}>
                                                            {data.name}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div>
                                        <FormControl variant={'filled'} fullWidth required>
                                            <InputLabel data-testid='inputLabel4' >
                                                {t('DASHBOARD.CUSTOMER_TITLE')}
                                            </InputLabel>
                                            <Select
                                                variant={'filled'}
                                                fullWidth style={{ marginBottom: 24, backgroundColor: PXBColors.white[500] }}
                                                labelId="customer-select-label"
                                                inputProps={{ 'data-testid': 'customerSelect' }}
                                                data-testid="customer-select"
                                                value={customerId}
                                                onChange={handleSetcustomerSelection}
                                                displayEmpty={!projectId && customer.customerListLoading}
                                            >
                                                {customers.map((data) => {
                                                    return (
                                                        <MenuItem id="customer-list" key={data.id} value={data.id}
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'left', fontSize: 14,
                                                                lineHeight: 1.5, fontWeight: 400,
                                                                overflow: 'hidden',
                                                                boxSizing: 'border-box',
                                                                whiteSpace: 'nowrap',
                                                                minHeight: 48,
                                                                paddingTop: 6,
                                                                paddingBottom: 6,
                                                                width: 'auto',
                                                                paddingLeft: 16,
                                                                paddingRight: 16
                                                            }}>
                                                            {data.name}

                                                        </MenuItem>

                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                            </Box>
                        </Box>
                    </>
                </DialogContent>
                <Divider style={{ color: 'grey' }} />
                <DialogActions style={{ justifyContent: 'space-between', marginTop: 7, marginBottom: 7, marginLeft: 16, marginRight: 17 }}>
                    <Button
                        style={{
                            textTransform: 'none',
                            border: `1% solid ${PXBColors.red[500]}`,
                        }}
                        id="btnCancel" data-testid="btnCancel"
                        variant="outlined"
                        color="error"
                        startIcon={<CloseIcon />}
                        onClick={(): void => onCancel()}>
                        {t('ACTIONS.CANCEL')}
                    </Button>
                    <Button
                        disabled={!projectId && !buildingId && !deviceId && !customerId}
                        style={{
                            backgroundColor: disableButton ? PXBColors.blue[500] : PXBColors.blue[50],
                            color: disableButton ? PXBColors.white[50] : PXBColors.blue[200],
                            textTransform: 'none',
                            cursor: 'pointer',
                            opacity: (projectId && buildingId && deviceId && customerId) ? 1 : 0.5,
                        }}
                        id="btnNextMaintenance"
                        data-testid="btnNextMaintenance"
                        variant="contained"
                        startIcon={<ArrowForwardIcon />}
                        onClick={NavigateToCreateMaintainence}
                    >
                        {t('ACTIONS.NEXT')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default CreateMaintenanceDialog
